<template>
    <div class="main" v-loading="isLoading">
        <h2>订单信息</h2>
        <ul>
            <li>
                <label>产品名称：</label>
                <p>{{ info.productName }}</p>
            </li>
            <li>
                <label>产品编号：</label>
                <p>{{ info.productNo }}</p>
            </li>
            <li>
                <label>订单号：</label>
                <p>{{ info.id }}</p>
            </li>
            <li>
                <label>订单状态：</label>
                <p>{{ info.orderStatusStr }}</p>
            </li>
            <li>
                <label>下单时间：</label>
                <p>{{ info.orderCreateTime }}</p>
            </li>
            <li>
                <label>订单金额：</label>
                <p>{{ info.totalPrice }}</p>
            </li>
            <li>
                <label>物流公司：</label>
                <p>{{ info.deliverName }}</p>
            </li>
            <li>
                <label>物流单号：</label>
                <p>{{ info.deliverNo }}</p>
            </li>
        </ul>
        <h2>退款</h2>
            <ul>
                <li>
                    <label>退款条件：</label>
                    <p>{{ info.refundCondition }}</p>
                </li>
            </ul>
        <h2>历史退款</h2>
        <v-table style="width: 100%;"
                 :data="tableData"
                 :column="tableColumn"
        >
            <template slot="refundNo" scope="props">
                <div style="word-break: break-all;">{{ props.data }}</div>
            </template>
        </v-table>
    </div>
</template>

<style lang="scss" scoped="scoped">
    .main {
        min-height: 100%;
        background-color: #F7F9FA;
        padding: 20px 15px;
        > h2 {
            font-size: 24px;
            &:nth-of-type(n+2) {
                margin-top: 60px;
            }
        }
        ul {
            list-style: none;
            li {
                height: 40px;
                line-height: 40px;
                label {
                    vertical-align: top;
                    height: 100%;
                    margin: 0;
                    width: 80px;
                    font-weight: bold;
                    text-align: right;
                }
                p {
                    display: inline-block;
                    vertical-align: top;
                    height: 100%;
                    margin: 0 0 0 10px;
                }
            }
        }
    }
</style>

<script>
    import Api from 'api/wenchuang'
    import Moment from 'moment'

    export default {
        data () {
            return {
                orderId: this.$route.params.orderId,
                info: {
                    productName: '',
                    productNo: '',
                    id: '',
                    orderStatusStr: '',
                    orderCreateTime: '',
                    totalPrice: '',
                    deliverName: '',
                    deliverNo: '',
                    refundCondition: ''
                },
                tableData: [],
                tableColumn: [
                    {
                        key: 'id',
                        name: '序号'
                    },
                    {
                        key: 'money',
                        name: '退款金额'
                    },
                    {
                        key: 'refundStatusStr',
                        name: '退款状态'
                    },
                    {
                        key: 'refundReason',
                        name: '退款原因'
                    },
                    {
                        key: 'refundNo',
                        name: '退款流水号',
                        type: 'slot',
                        slot: 'refundNo'
                    },
                    {
                        key: 'rejectReason',
                        name: '拒绝理由'
                    },
                    {
                        key: 'applyPerson',
                        name: '退款发起人'
                    },
                    {
                        key: 'refundMark',
                        name: '退款备注'
                    },
                    {
                        key: 'applyTime',
                        name: '退款申请时间'
                    },
                    {
                        key: 'handleTime',
                        name: '处理时间'
                    }
                ],
                isLoading: false
            }
        },
        watch: {
            // 监听路由变化
            '$route' () {
                this.orderId = this.$route.params.orderId;
                this.getDetailsData();
            }
        },
        methods: {

            // 获取订单详情数据
            getDetailsData () {
                this.isLoading = true;
                Api.getOrderDetails(this.orderId)
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                            let data = res.data;
                            let tableData = [];
                            this.info = {
                                productName: data.productName,
                                productNo: data.productNo,
                                id: data.id,
                                orderStatusStr: data.orderStatusStr,
                                orderCreateTime: Moment(data.orderCreateTime).format('YYYY-MM-DD HH:mm:ss'),
                                totalPrice: data.totalPrice,
                                deliverName: data.deliverName,
                                deliverNo: data.deliverNo,
                                refundCondition: data.refundCondition
                            }
                            data.refundModels.forEach((item) => {
                                tableData.push({
                                    id: item.id,
                                    money: item.money,
                                    refundStatusStr: item.refundStatusStr,
                                    refundReason: item.refundReason,
                                    refundNo: item.refundNo,
                                    rejectReason: item.rejectReason,
                                    applyPerson: item.applyPerson,
                                    refundMark: item.refundMark,
                                    applyTime: Moment(item.applyTime).format('YYYY-MM-DD HH:mm:ss'),
                                    handleTime: Moment(item.handleTime).format('YYYY-MM-DD HH:mm:ss')
                                })
                            })
                            this.tableData = tableData;
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: res.message || '请求失败'
                            })
                        }
                        this.isLoading = false;
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$alert({
                            title: '错误',
                            message: '请求失败',
                            showCancelButton: false,
                            closeOnClickModal: false
                        }).then(() => {
                            window.history.back();
                        })
                    })
            }

        },
        created () {
            this.getDetailsData();
        }
    }
</script>




// WEBPACK FOOTER //
// Main.vue?1f63c491